import classNames from 'classnames';
import { usePaletteConfig } from 'palette/Config';
import { Svg } from 'palette/Svg';
import { BEMBlock } from '@helpers/classnames';
import '../styles/HeaderLogo.scss';

export function MainHeaderLogo({
    href, ariaLabel, logo, className
}) {
    const { logoPath } = usePaletteConfig();
    const [block, BEMElement] = BEMBlock('header-logo');
    return (
        <div className={classNames(block, className)}>
            <a
                aria-label={ariaLabel}
                className={BEMElement('link')}
                href={href}
            >
                <Svg
                    className={BEMElement('svg')}
                    name={logo}
                    svgUrl={logoPath}
                />
            </a>
        </div>
    );
}
